import { render, staticRenderFns } from "./OtherKnownNames.vue?vue&type=template&id=59c305aa&scoped=true&"
import script from "./OtherKnownNames.vue?vue&type=script&lang=js&"
export * from "./OtherKnownNames.vue?vue&type=script&lang=js&"
import style0 from "./OtherKnownNames.vue?vue&type=style&index=0&id=59c305aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c305aa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText,VCardTitle})
